import FieldEstimate from "../../../generic/estimate/estimate"
import FieldConfig from "../../../proto/field-config"
import Task from "../../../../model2/task/task"
import ItemModelV2 from "../../../../model2/item2/item-model"

export default class FieldTaskEstimate extends FieldEstimate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Task estimate"
        this.label      = _.get(config, 'label', 'Task estimate')

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeTaskEstimate
    }


    tableCellOnValueChange = async (item: ItemModelV2, value: number) => {

        item.task.estimate = value ? value : null

        item.task.save()
    }

}